import { Box, Text, VStack } from '@chakra-ui/react'
import { getDateTimeRangeString, PracticeVisitDraft, visitTypeNames } from '@hb/shared'
import { SolidActionButton } from '../../../components/Buttons/ActionButton'

export const VisitDraftPreview = ({
  visitDraft,
  onOpenModal,
}: {
  visitDraft: PracticeVisitDraft
  onOpenModal?: () => void
}) => (
  <VStack w="100%" p={3} align="stretch" spacing={2}>
    <Box>
      <Text fontSize="sm" fontWeight={500} color="gray.600">
        Patient
      </Text>
      <Text fontSize="md">
        {visitDraft.patientFirst} {visitDraft.patientLast}
      </Text>
    </Box>
    <Box>
      <Text fontSize="sm" fontWeight={500} color="gray.600">
        Visit Type
      </Text>
      <Text fontSize="md">{visitTypeNames[visitDraft.type]}</Text>
    </Box>
    <Box>
      <Text fontSize="sm" fontWeight={500} color="gray.600">
        Time
      </Text>
      <Text fontSize="sm">
        {getDateTimeRangeString(visitDraft.startTimeUnix, visitDraft.endTimeUnix)}
      </Text>
    </Box>
    <Box>
      <Text fontSize="sm" fontWeight={500} color="yellow.600">
        Status: Draft (Not Authenticated)
      </Text>
    </Box>
    {onOpenModal ? (
      <SolidActionButton size="sm" onClick={onOpenModal} mt={2}>
        View Full Details
      </SolidActionButton>
    ) : null}
  </VStack>
)
